import React from "react";
import { useSettings } from "../public-cms/hooks";

const PREFILL =
    "Hello! I'd like to enquire about a trip with Dream International Travel & Tours.";

/**
 * Always-visible WhatsApp floating action button (bottom-right).
 * Number comes from CMS settings (whatsappNumber, falling back to contactPhone).
 */
function WhatsAppFAB() {
    const settings = useSettings();
    const digits = String(settings.whatsappNumber || settings.contactPhone || "").replace(
        /[^\d]/g,
        ""
    );
    if (!digits) return null;

    const href = `https://wa.me/${digits}?text=${encodeURIComponent(PREFILL)}`;

    return (
        <a
            href={href}
            className="di-whatsapp-fab"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
        >
            <i className="fab fa-whatsapp" aria-hidden="true" />
        </a>
    );
}

export default WhatsAppFAB;
